import type { RouteLocationOptions } from '~/hooks/useRouter';
import { logger } from '~/scripts/logger';

export const getHrefString = (href: string | RouteLocationOptions): string => {
  if (typeof href === 'string') {
    return href;
  }
  const { path, query, hash } = href;
  const queryString = query
    ? `?${new URLSearchParams(query as Record<string, string>).toString()}`
    : '';
  return `${path}${queryString}${hash ? `#${hash}` : ''}`;
};

export const validateHref = (href: string): void => {
  if (href && !/^mailto:|^https?:\/\/|^\//i.test(href)) {
    logger.warn('Invalid href: ', href);
  }
};

export const isExternalLink = (href: string): boolean => {
  const isMailTo = href.startsWith('mailto:');
  const isRelative = href.startsWith('/');
  if (isRelative || isMailTo) {
    return false;
  }
  const isInternal =
    href.startsWith('https://www.nerdydata.com/') ||
    href.startsWith('http://localhost:');
  return !isInternal;
};

export const getLinkSecurityAttributes = (
  href: string,
  rel?: string
): string | undefined => {
  const isExternalHref = isExternalLink(href);
  return isExternalHref ? `noopener nofollow ${rel || ''}` : rel || '';
};

export const isMailToLink = (href: string): boolean => {
  return href.startsWith('mailto:');
};

export const isRelativeLink = (href: string): boolean => {
  return href.startsWith('/');
};
